import Button from "../../../../components/common/ui/Button";
import { history } from "../../../../_helpers/history";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import SelectInput from "../../../../components/common/ui/Inputs/SelectInput";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import { menuActions } from "../../../../_store/menu.slice";
import menuSchema from "../../../../validation/Admin/menuSchema";
import { RadioInput } from "../../../../components/common/ui/Inputs";
import CustomLoader from "../../../../components/common/ui/Loader";

function CreateOrEditMenu() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const { menuForm, getParentMenuList, loading } = useSelector(
    (state) => state?.menu,
  );
  const [filteredMenu, setFilteredMenu] = useState([]);

  const { ButtonTarget, routeOptions } = useSelector(
    (state) => state?.dropDown,
  );

  const menuID = location?.state ? location?.state?.menuID : 0;

  const loadMenuData = async (id) => {
    if (!id || id === 0) return;

    try {
      const result = await dispatch(menuActions?.getMenuItemByID(id));
      dispatch(menuActions?.updateMenuForm(result?.payload?.data));
    } catch (err) {
      showToastNotification("Failed to get Committee Details", "error");
    }
  };

  useEffect(() => {
    if (menuID === 0) {
      dispatch(menuActions.resetMenuForm());
    } else {
      loadMenuData(menuID);
    }
  }, [menuID, dispatch]);

  useEffect(() => {
    const filteredData = getParentMenuList?.data?.filter(
      (menu) => menu?.label !== menuForm?.label,
    );
    setFilteredMenu(filteredData);
  }, [getParentMenuList, menuForm?.label]);

  const getMenuParentList = () => {
    dispatch(menuActions?.getParentMenuList());
  };

  useEffect(() => {
    getMenuParentList();
  }, []);

  const handleChange = (e, select) => {
    const formData = { ...menuForm };
    if (select) {
      formData[select] = e?.value === undefined ? null : e?.value;
      dispatch(menuActions.updateMenuForm(formData));
      return;
    }
    const { name, value, type } = e?.target;
    if (name === "label") {
      const regex = /^[A-Za-z0-9 -]*$/;
      if (!regex.test(value)) {
        return;
      }
    }
    if (value.startsWith(" ")) return;
    if (name === "order") {
      const onlyNums = value.replace(/\D/g, ""); // remove all non-digits
      formData[name] = onlyNums;
    } else if (name === "routeMethod") {
      debugger;
      formData[name] = value;
      if (value === "external") {
        formData["target"] = "_blank";
      }
    } else {
      formData[name] =
        type === "radio" ? (value === "true" ? true : false) : value;
    }
    dispatch(menuActions.updateMenuForm(formData));
  };

  const handleFormSubmit = async (e) => {
    debugger;
    setIsPending(true);
    e?.preventDefault();
    setErrorMessage({});
    const { error } = menuSchema(menuForm);
    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    //API call after validation
    setIsPending(true);

    try {
      const result = menuID
        ? await dispatch(menuActions?.updateMenuItem(menuForm))
        : await dispatch(menuActions?.CreateMenuItem(menuForm));

      setIsPending(false);

      if (result?.payload?.status === 1) {
        showToastNotification(result?.payload?.message, "success");
        dispatch(menuActions.resetMenuForm());
        history?.navigate("/Admin/Menu", {
          state: { menuID: 0 },
        });
      } else {
        showToastNotification(
          result?.error?.message || "Something went wrong",
          "error",
        );
      }
    } catch (error) {
      setIsPending(false);
      showToastNotification("Failed to save menu item", "error");
    }
  };

  const handleFormReset = () => {
    setErrorMessage({});
    if (menuID === 0) {
      dispatch(menuActions?.resetMenuForm());
    } else {
      loadMenuData(menuID);
    }
  };
  if (loading) return <CustomLoader />;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Menu</h1>
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/Menu", {
              tate: { menuID: 0 },
            });
            dispatch(menuActions.resetMenuForm());
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          {menuID ? "Edit " : "Create "}Menu
        </h1>
        <form
          onSubmit={(e) => {
            handleFormSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
          className="p-3 row"
        >
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Menu Name"
                placeholder="Menu name"
                name="label"
                id="menuname"
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={menuForm?.label}
                maxLength={28}
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="routeMethod"
                id="routeMethod"
                label="Route Method"
                options={routeOptions}
                handleChange={(e) => handleChange(e)}
                selectedValue={menuForm?.routeMethod}
                value={menuForm?.routeMethod}
              />
            </div>
            {menuForm?.routeMethod === "external" && (
              <div className="col-md-4">
                <TextInput
                  label="URL"
                  placeholder="URL"
                  name="url"
                  id="url"
                  handleChange={(e) => handleChange(e)}
                  required={menuForm?.routeMethod === "external" ? true : false}
                  errorMessage={errorMessage}
                  value={menuForm?.url}
                />
              </div>
            )}

            {/* <div className="col-md-4">
              <SelectInput
                options={ButtonTarget}
                name="target"
                id="target"
                label="Target"
                required
                handleChange={(e) => handleChange(e, "target")}
                errorMessage={errorMessage}
                value={menuForm?.target}
              />
            </div> */}
            <div className="col-md-4">
              <SelectInput
                // options={getParentMenuList?.data}
                options={filteredMenu}
                name="parent"
                id="parent"
                label="Parent"
                //  required
                handleChange={(e) => handleChange(e, "parent")}
                errorMessage={errorMessage}
                value={menuForm?.parent}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                label="Order"
                placeholder="Order"
                name="order"
                id="order"
                handleChange={(e) => handleChange(e)}
                errorMessage={errorMessage}
                value={menuForm?.order}
                maxLength={3}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <Button
              label={`${menuID === 0 ? "Submit" : "Update"}`}
              type="submit"
              status="secondary"
              disabled={isPending}
            />
            <Button label="Reset" type="reset" status="reset" />
          </div>
        </form>
      </div>
    </>
  );
}

export default CreateOrEditMenu;
